const therapistNames: Record<string, string> = {
  wendy: 'Венди',
  artem: 'Артём',
  una: 'Уна',
  finch: 'Гарольд',
  harold: 'Гарольд',
}

export default function SessionSeparator({ therapist, date }: { therapist: string; date: string }) {
  const d = new Date(date)
  const name = therapistNames[therapist] || therapist
  const dateStr = d.toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })
  const label = `Сессия с ${name}, ${dateStr}`

  return (
    <div className="flex items-center gap-3 my-6">
      <div className="flex-1 h-px bg-neutral-300/60" />
      <span className="text-xs text-neutral-500 bg-white/80 px-3 py-1 rounded-full whitespace-nowrap">{label}</span>
      <div className="flex-1 h-px bg-neutral-300/60" />
    </div>
  )
}
